import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { graphql } from 'gatsby';
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer';

import { Layout, Link } from '$components';
import NextPrevious from '../components/NextPrevious';
import config from '../../config';
import { Edit, StyledHeading, StyledMainWrapper } from '../components/styles/Docs';

const forcedNavOrder = config.sidebar.forcedNavOrder;

export default class MDXRuntimeTest extends Component {
  render() {
    const { data, pageContext } = this.props;

    if (!data || !data.site) {
      return this.props.children;
    }

    if (!data) {
      return this.props.children;
    }
    const {
      allMdx,
      mdx,
      site: {
        siteMetadata: { docsLocation, title },
      },
    } = data;
    const is2005Viewer = pageContext && pageContext.is2005Viewer;

    const githubIcon = require('../components/images/github.svg').default;
    const filteredEdges = allMdx.edges.filter(({ node }) => {
      const slug = node.fields.slug;
      const is2005 = slug.startsWith('/2005');
      return is2005Viewer ? is2005 : !is2005;
    });

    const navItems = filteredEdges
      .map(({ node }) => node.fields.slug)
      .filter((slug) => slug !== '/')
      .sort()
      .reduce(
        (acc, cur) => {
          const navOrder = is2005Viewer ? ['/2005'] : forcedNavOrder;

          if (navOrder.find((url) => url === cur)) {
            const existing = acc[cur] || [];
            return { ...acc, [cur]: [...existing, cur] };
          }

          let prefix = cur.split('/')[1];

          if (config.gatsby && config.gatsby.trailingSlash) {
            prefix = prefix + '/';
          }

          if (prefix && navOrder.find((url) => url === `/${prefix}`)) {
            const key = `/${prefix}`;
            const existing = acc[key] || [];
            return { ...acc, [key]: [...existing, cur] };
          } else {
            return { ...acc, items: [...acc.items, cur] };
          }
        },
        { items: [] }
      );

    const navOrder = is2005Viewer ? ['/2005'] : forcedNavOrder;

    const nav = navOrder
      .reduce((acc, cur) => {
        const items = navItems[cur] || [];
        return acc.concat(items);
      }, [])
      .concat(navItems.items)
      .map((slug) => {
        if (slug) {
          const { node } = filteredEdges.find(({ node }) => node.fields.slug === slug);

          const url = is2005Viewer ? `/NBH${node.fields.slug}` : node.fields.slug;

          return { title: node.fields.title, url };
        }
      });

    // meta tags
    const metaTitle = mdx.frontmatter.metaTitle;

    const metaDescription = mdx.frontmatter.metaDescription;

    let canonicalUrl = config.gatsby.siteUrl;

    canonicalUrl =
      config.gatsby.pathPrefix !== '/' ? canonicalUrl + config.gatsby.pathPrefix : canonicalUrl;
    canonicalUrl = canonicalUrl + (is2005Viewer ? `/NBH${mdx.fields.slug}` : mdx.fields.slug);

    return (
      <Layout {...this.props}>
        <Helmet>
          {metaTitle ? <title>{metaTitle}</title> : null}
          {metaTitle ? <meta name="title" content={metaTitle} /> : null}
          {metaDescription ? <meta name="description" content={metaDescription} /> : null}
          {metaTitle ? <meta property="og:title" content={metaTitle} /> : null}
          {metaDescription ? <meta property="og:description" content={metaDescription} /> : null}
          {metaTitle ? <meta property="twitter:title" content={metaTitle} /> : null}
          {metaDescription ? (
            <meta property="twitter:description" content={metaDescription} />
          ) : null}
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
        <div className={'titleWrapper'}>
          <StyledHeading>{mdx.fields.title}</StyledHeading>
        </div>
        <StyledMainWrapper>
          <MDXRenderer>{mdx.body}</MDXRenderer>
        </StyledMainWrapper>
        <div className={'addPaddTopBottom'}>
          <NextPrevious mdx={mdx} nav={nav} />
        </div>
        <StyledMainWrapper>
          <p style={{ textAlign: 'center', marginBottom: '20px' }}>
            © JiMiTao-ABeautyWay {new Date().getFullYear()}
          </p>
        </StyledMainWrapper>
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query ($id: String!) {
    site {
      siteMetadata {
        title
        docsLocation
      }
    }
    mdx(fields: { id: { eq: $id } }) {
      fields {
        id
        title
        slug
      }
      body
      tableOfContents
      parent {
        ... on File {
          relativePath
        }
      }
      frontmatter {
        metaTitle
        metaDescription
      }
    }
    allMdx {
      edges {
        node {
          fields {
            slug
            title
          }
        }
      }
    }
  }
`;
